import { useDialogAlert } from '@app/components/DialogAlert';
import { useHoldClickHandlers } from '@app/hooks/use-hold-click-handlers';
import { Add, Delete, Remove } from '@material-ui/icons';
import React from 'react';

import classes from './styles.module.css';

type Props = {
  complementId: string;
  value: number;
  onPlusClick: (isHolding: boolean) => void;
  onMinusClick: (isHolding: boolean) => void;
  max: number;
  plusButtonIsDisabled: boolean;
};

const DELAY = 150;
const INITIAL_DELAY = 500;

export default function AmountControl({
  value,
  onPlusClick,
  onMinusClick,
  max,
  complementId,
  plusButtonIsDisabled,
}: Props) {
  const { DialogAlert, dialogRef } = useDialogAlert();

  const minusIsDisabled = value <= 0;

  // const minusHandlers = useHoldClickHandlers(onMinusClick, {
  //   delay: DELAY,
  //   initialDelay: INITIAL_DELAY,
  //   disabled: minusIsDisabled,
  // });
  // const plusHandlers = useHoldClickHandlers(onPlusClick, {
  //   delay: DELAY,
  //   initialDelay: INITIAL_DELAY,
  //   disabled: plusButtonIsDisabled,
  // });

  function alertMaxReached() {
    dialogRef.current?.alert({
      message: `Você já adicionou o limite máximo de ${max}`,
    });
  }

  const minusButtonDisplay = minusIsDisabled ? 'none' : 'block';

  return (
    <div className={classes.container}>
      <button onClick={() => onMinusClick(false)} disabled={minusIsDisabled} style={{ display: minusButtonDisplay }}>
        {value === 1 ? <Delete style={{ color: '#FF6161', fontSize: 20 }} /> : <Remove style={{ color: '#FF6161' }} />}
      </button>
      <span>{value > 0 ? value : ' '}</span>
      <button
        onClick={plusButtonIsDisabled ? alertMaxReached : () => onPlusClick(false)}
        data-cy={`add-complement-${complementId}`}
      >
        <Add style={{ color: plusButtonIsDisabled ? '#999' : '#65D870' }} />
      </button>
      {DialogAlert}
    </div>
  );
}
